<template>
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-plus-circle fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Créer un service</h2>
      </div>
      <button class="btn btn-outline-secondary" @click="$router.back()">
        <i class="bi bi-arrow-left"></i> Retour
      </button>
    </div>

    <!-- Formulaire -->
    <div class="card shadow-sm rounded card-clinique p-4">

      <!-- Erreur générale (ex: doublon) -->
      <div v-if="globalError" class="alert alert-danger py-2 mb-3">
        {{ globalError }}
      </div>

      <form @submit.prevent="submit">
        <div class="row g-3">

          <!-- Nom -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">Nom du service *</label>
            <input
              v-model="form.nom"
              placeholder="nom service"
              type="text"
              class="form-control form-control-clinique"
              :class="{ 'is-invalid': error.nom }"
              required
              @input="error.nom = ''; globalError = ''"
            />
            <div class="invalid-feedback">{{ error.nom }}</div>
          </div>

          <!-- Type de service -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">Type de service *</label>
            <select
              v-model="form.type"
              class="form-select form-select-clinique"
              required
            >
              <option value="">-- Sélectionner --</option>
              <option
                v-for="ts in typeServices"
                :key="ts.id"
                :value="ts.id"
              >
                {{ ts.nom }}
              </option>
            </select>
          </div>
          <!-- Code -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">Code</label>
            <input
              v-model="form.code"
              placeholder="code"
              type="text"
              class="form-control form-control-clinique"
            />
          </div>

          <!-- Prix -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">Prix (FCFA) *</label>
            <input
              v-model.number="form.prix"
              placeholder="prix"
              type="number"
              min="0"
              class="form-control form-control-clinique"
              required
            />
          </div>
          

          <!-- Statut -->
          <div class="col-md-6 d-flex align-items-end">
            <div class="form-check form-switch">
              <input
                v-model="form.isEnabled"
                class="form-check-input"
                type="checkbox"
                id="isEnabled"
              />
              <label class="form-check-label fw-semibold" for="isEnabled">
                Service actif
              </label>
            </div>
          </div>

        </div>

        <!-- Actions -->
        <div class="mt-4 d-flex justify-content-end gap-2">
          <button
  type="submit"
  class="btn btn-primary btn-lg d-flex align-items-center"
  :disabled="isLoading"
>
  <span
    v-if="isLoading"
    class="spinner-border spinner-border-sm me-2"
    role="status"
  ></span>

  <i v-else class="bi bi-check-circle me-1"></i>

  {{ isLoading ? 'Enregistrement...' : 'Enregistrer' }}
</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from '@/api';

export default {
  name: 'CreateService',
  data() {
    return {
      isLoading: false,
      typeServices: [],
      form: {
        nom: '',
        type: '',
        code: '',
        prix: null,
        isEnabled: true,
        estPaye: false
      },
      error: {
        nom: ''
      },
      globalError: ''
    };
  },
  methods: {
    async loadTypeServices() {
      try {
        const res = await api.getItems('type_services');
        this.typeServices = res.data?.data || res.data;
      } catch (e) {
        console.error('Erreur chargement type services', e);
      }
    },
    validateForm() {
      this.error = {
        nom: this.form.nom.trim() ? '' : 'Le nom est requis'
      };
      if (Number(this.form.prix) < 0) this.globalError = 'Le prix doit être un nombre positif ou nul (0 = gratuit).';
      else if (this.globalError === 'Le prix doit être un nombre positif ou nul (0 = gratuit).') this.globalError = '';
      if (Number(this.form.prix) < 0) return false;
      return !Object.values(this.error).some(err => err !== '');
    },
    async submit() {
      if (!this.validateForm() || this.isLoading) return;

      this.globalError = '';

      try {
        this.isLoading = true;
        await api.createItem('services', {
          nom: this.form.nom.trim(),
          type: this.form.type,
          code: this.form.code,
          prix: this.form.prix,
          isEnabled: this.form.isEnabled,
          estPaye: this.form.estPaye
        });

        this.$router.push({ name: 'liste_service' });
      } catch (e) {
        console.error('Erreur création service', e);

        // Le backend renvoie 409 + message clair en cas de doublon
        if (e.response?.status === 409) {
          this.error.nom = e.response.data?.message;
          this.globalError = e.response.data?.message;
        } else {
          this.globalError = e.response?.data?.message
            || 'Erreur lors de la création du service.';
        }
      } finally {
        this.isLoading = false;
      }
    }
  },
  created() {
    this.loadTypeServices();
  }
};
</script>
<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
}
</style>